// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import enNavigation from './locales/en/navigation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation, navigation: enNavigation }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;
